import React from 'react';
import CircularProgress from 'material-ui/CircularProgress';

function CenteredLoadingAnimation(props) {
  const size = props.size || 80;

  const style = {
    position: 'absolute',
    top: '48%',
    left: '50%',
    marginTop: -(size/2),
    marginLeft: -(size/2),
  };

  return (
    <CircularProgress
      size={size}
      thickness={5}
      style={style}
    />
  );
}

export default CenteredLoadingAnimation;



// WEBPACK FOOTER //
// ./src/components/CenteredLoadingAnimation/CenteredLoadingAnimation.js